import React from "react";
import { buildFaqSchema, stringifyJsonLd } from "@/utils/faqSchema";
import FaqAccordion from "./FaqAccordion";

// Server component: fetches nothing itself, just renders schema + static shell.
// All interactivity (open/close, animations) lives in FaqAccordion (client).
export default function BlogFaq({
  data,
  title = "Frequently Asked Questions",
  subtitle = "Find quick answers to the most common questions about our programme"
}) {

  const faqData = data || [];
  const faqSchema = buildFaqSchema(faqData);

  if (!faqData || faqData.length === 0) {
    return null;
  }

  return (
    <section className="page-container bg-white my-[20px] md:my-[30px] lg:my-[50px]">
      {faqSchema && (
        <script
          id="FAQSchema"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: stringifyJsonLd(faqSchema) }}
        />
      )}

      {/* Header */}
      <div className="text-center mb-[12px] md:mb-[20px]">
        <h2
          className="mb-[12px] tracking-[-1.2px] sm:text-[42px] text-[24px] text-left"
          style={{ fontFamily: "saans-bold" }}
        >
          {title}
        </h2>
      </div>

      {/* Interactive accordion (client) */}
      <FaqAccordion faqData={faqData} />
    </section>
  );
}